
<mat-form-field [appearance]="appearance" [ngClass]="classes" [class.searchable-select--compact]="compact" [floatLabel]="floatLabel">

  <!-- Label -->
  <mat-label *ngIf="label">{{label}}</mat-label>

  <!-- Due to some fun errors, you can't change multiple on the fly. So we render two different selects. -->
  @if (!multiple) {
    <mat-select [formControl]="control" (selectionChange)="onSelectChange($event)" [disabled]="disabled" [panelClass]="{'overflow-clip': true}" [panelWidth]="panelWidth">

      <!-- Search input -->
      <mat-form-field [appearance]="appearance" [ngClass]="classes">
        <input matInput #searchInput autocomplete="dropdown-search" [(ngModel)]="searchTerm" (keydown)="$event.stopPropagation()" (keyup)="onSearchChange(searchInput.value)" [placeholder]="placeholder">
      </mat-form-field>
  
      <!-- Multi-select label -->
      <mat-select-trigger>{{displayValueText}}</mat-select-trigger> 
      
      <!-- Selection Options -->
      <div style="height: 75%; overflow: auto;" class="hide-scrollbar">
        <mat-option *ngFor="let item of filteredData" [value]="item.value" [ngClass]="$any(item).cssClass || ''">
          <mat-icon *ngIf="icon" [style.color]="iconColor" style="font-size: 18px; height: 18px; width: 18px; margin-right: 4px; vertical-align: middle;">{{icon}}</mat-icon>{{item.display}}<span *ngIf="$any(item).cssClass === 'option-pending'" class="pending-suffix"> (Pending <mat-icon class="pending-icon">hourglass_empty</mat-icon>)</span>
        </mat-option>
      </div>
  
    </mat-select>
    
  } @else {
    <mat-select [formControl]="control" multiple (selectionChange)="onSelectChange($event)" [disabled]="disabled" [panelClass]="{'overflow-clip': true}" [panelWidth]="panelWidth">

      <!-- Search input -->
      <mat-form-field [appearance]="appearance" [ngClass]="classes">
        <input matInput #searchInput autocomplete="dropdown-search" [(ngModel)]="searchTerm" (keydown)="$event.stopPropagation()" (keyup)="onSearchChange(searchInput.value)" [placeholder]="placeholder">
      </mat-form-field>
  
      <!-- Multi-select label -->
      <mat-select-trigger>{{displayValueText}}</mat-select-trigger> 
      
      <!-- Selection Options -->
      <div style="height: 75%; overflow: auto;" class="hide-scrollbar">
        <mat-option *ngFor="let item of filteredData" [value]="item.value" [ngClass]="$any(item).cssClass || ''">
          <mat-icon *ngIf="icon" [style.color]="iconColor" style="font-size: 18px; height: 18px; width: 18px; margin-right: 4px; vertical-align: middle;">{{icon}}</mat-icon>{{item.display}}<span *ngIf="$any(item).cssClass === 'option-pending'" class="pending-suffix"> (Pending <mat-icon class="pending-icon">hourglass_empty</mat-icon>)</span>
        </mat-option>
      </div>
  
    </mat-select>
  }



</mat-form-field>
